import { Div, Text } from "@tblabs/truffle";
import { AgentsProvider } from "../Services/Agents/AgentsProvider";
import { Router } from "../Services/Router";
import { Step } from "../Steps/Step/Step";
import { Menu } from "./Utils/Menu";


export class AgentBox extends Div
{
    constructor(_agents: AgentsProvider, _router: Router, step: Step<any>, refresh: () => void)
    {
        super("agent-box");

        const agentLabel = new Text(step.Data.AssignedAgentId, v =>
        {
            const agent = _agents.Get(v as string);
            return agent ? agent.AsString : "Agent nie przypisany";
        });

        agentLabel.OnClick(() =>
        {
            const agentsToAssignMenu = this.BuildAgentsList(_agents, step, refresh);

            this.Append(
                new Menu(agentsToAssignMenu)
            );
        });

        agentLabel.On("dblclick", () =>
        {
            _router.GoToAgentTasks(step.Data.AssignedAgentId.value);
        });

        this.Append(agentLabel);
    }

    private BuildAgentsList(_agents: AgentsProvider, step: Step<any>, refresh: () => void)
    {
        const agentsToAssignMenu = _agents.All.Items
            .reduce((acc, x) => ({
                ...acc, [x.AsString]: () =>
                {
                    step.Data.AssignedAgentId.value = x.Id;
                    step.CallOnChange();
                    refresh();
                }
            }), {});

        if (step.Data.AssignedAgentId.value)
        {
            agentsToAssignMenu["(nie przypisany)"] = () =>
            {
                step.Data.AssignedAgentId.value = "";
                step.CallOnChange();
                refresh();
            };
        }

        return agentsToAssignMenu;
    }
}
